var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaSidebarIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.978027 10.2754C0.978027 4.75254 5.45518 0.275391 10.978 0.275391H33.7866C39.3095 0.275391 43.7866 4.75254 43.7866 10.2754V33.084C43.7866 38.6068 39.3095 43.084 33.7866 43.084H10.978C5.45518 43.084 0.978027 38.6068 0.978027 33.084V10.2754Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4029 28.8072C13.5796 29.8749 14.5072 30.6891 15.625 30.6891H29.1393C30.3833 30.6891 31.3917 29.6806 31.3917 28.4367V24.146M13.4029 28.8072C13.3829 28.6867 13.3726 28.5629 13.3726 28.4367V14.9223C13.3726 13.6784 14.381 12.6699 15.625 12.6699H29.1393C30.3833 12.6699 31.3917 13.6784 31.3917 14.9223V24.146M13.4029 28.8072L17.7057 24.5044C18.4716 23.8343 19.5916 23.7609 20.4384 24.3254L21.0117 24.7076C21.8279 25.2517 22.9023 25.2051 23.6682 24.5924L26.6505 22.2065C27.4107 21.5984 28.4695 21.5506 29.2776 22.0719C29.3672 22.1297 29.4469 22.2012 29.5222 22.2766L31.3917 24.146M21.2559 18.3009C21.2559 19.5449 20.2475 20.5533 19.0035 20.5533C17.7596 20.5533 16.7511 19.5449 16.7511 18.3009C16.7511 17.0569 17.7596 16.0485 19.0035 16.0485C20.2475 16.0485 21.2559 17.0569 21.2559 18.3009Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaSidebarIcon);
export default __webpack_public_path__ + "static/media/mediaSidebarIcon.355420057fa1643328430167885a3cf6.svg";
export { ForwardRef as ReactComponent };